import React from 'react'
import { Modal } from 'antd'
import { messageTypes } from '../../../../actions/messages'
import { takeElementWithIdFromArr, getCookie, openNotificationPopup } from '../../../../actions/helpers'
import StyledStackDescsForm from '../../../../styledComponents/sections/settings/stackDescriptions/stackDescriptionForm'
import { stackTypesOverlordGet } from '../../../../actions/'

class StacksModalSettings extends React.Component {
  state = {
    singleData: {},
    overlordStackTypes: []
  }

  handleCancel = () => {
    const { setDataId, showAddRecordModal } = this.props
    showAddRecordModal(false)
    setDataId(null)
  }

  componentDidUpdate (prevProps, prevState) {
    const { dataId, data } = this.props
    if (prevProps.dataId !== dataId) {
      const singleData = takeElementWithIdFromArr(dataId, data)
      this.setState({ singleData })
    }
  }

  componentDidMount () {
    this._isMounted = true
    this.getStackTypesFromOverlord()
  }

  componentWillUnmount () {
    this._isMounted = true
  }

  getStackTypesFromOverlord = () => {
    const { language } = this.props
    stackTypesOverlordGet(getCookie('_token')).then((json) => {
      if (this._isMounted) {
        if (json.status === 'ok') {
          this.setState({
            overlordStackTypes: json.response
          })
        } else if (json.status === 'err') {
          openNotificationPopup(messageTypes[language].oops, json.response[language], 'frown')
        }

        this.setState({
          loading: false
        })
      }
    })
  }

  render () {
    const {
      language, dataId, isNewRecord, loading,
      updateRecord, addRecord, machines
    } = this.props
    const { singleData } = this.state
    return (
      <div>
        <Modal
          maskClosable={false}
          width={1000}
          visible={!!(dataId || isNewRecord)}
          title={
            (isNewRecord && messageTypes[language].new_stack_description) ||
            (
              singleData &&
              messageTypes[language].stack_type_description) + ': ' + (singleData && singleData.stack_type)
          }
          onCancel={this.handleCancel}
          footer={null}
        >
          <StyledStackDescsForm
            machines={machines}
            isNewRecord={isNewRecord}
            data={singleData || {}}
            language={language}
            onCancel={this.handleCancel}
            updateRecord={updateRecord}
            addRecord={addRecord}
            loading={loading}
            overlordStackTypes={this.state.overlordStackTypes}
          />
        </Modal>
      </div>
    )
  }
}

export default StacksModalSettings
